<template>
  <v-footer class="app-footer">
    <div class="footer-inner">
      <!-- Sol: Copyright -->
      <div class="footer-section footer-section--left">
        <div class="footer-brand">
          <div class="footer-brand-dot" />
          <span class="footer-brand-name">Quatro</span>
        </div>
        <span class="footer-copy">
          &copy; {{ currentYear }} Tüm hakları saklıdır.
        </span>
      </div>

      <!-- Orta: Logo -->
      <div class="footer-section footer-section--center">
        <v-img
          :src="footerLogo"
          height="auto"
          width="80"
          contain
          class="footer-logo"
        />
      </div>

      <!-- Sağ: Geliştirici + Versiyon -->
      <div class="footer-section footer-section--right">
        <span class="footer-dev-label">{{ $t("developed") }}</span>
        <a
          href="http://mobilulasim.com"
          class="footer-link"
          target="_blank"
          rel="noopener"
        >
          İpos Mobil Ulaşım
          <v-icon icon="mdi-open-in-new" size="11" class="footer-link-icon" />
        </a>
        <div class="footer-divider" />
        <div class="footer-version">
          <v-icon icon="mdi-tag-outline" size="11" class="mr-1" />
          {{ $t("version") }}
        </div>
      </div>
    </div>
  </v-footer>
</template>

<script>
import footerLogo from "../../../public/assets/img/quatro_black_logo.svg";

export default {
  data() {
    return {
      footerLogo,
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
/* ── Footer Kabı ── */
.app-footer {
  background: transparent !important;
  border-top: 1px solid rgba(15, 23, 42, 0.06) !important;
  padding: 0 !important;
  min-height: 56px !important;
}

.footer-inner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  height: 56px;
  gap: 16px;
}

/* ── Seksiyonlar ── */
.footer-section {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}
.footer-section--center {
  justify-content: center;
  flex: 0 0 auto;
}
.footer-section--right {
  justify-content: flex-end;
}

/* ── Sol: Marka ── */
.footer-brand {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-brand-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  flex-shrink: 0;
}
.footer-brand-name {
  font-size: 0.9em;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.2px;
}
.footer-copy {
  font-size: 0.85em;
  color: #94a3b8;
}

/* ── Orta: Logo ── */
.footer-logo {
  opacity: 0.5;
  filter: grayscale(1);
  transition: opacity 0.2s, filter 0.2s;
}
.footer-logo:hover {
  opacity: 1;
  filter: none;
}

/* ── Sağ: Dev + Versiyon ── */
.footer-dev-label {
  font-size: 0.85em;
  color: #94a3b8;
}
.footer-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85em;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
  transition: color 0.15s;
}
.footer-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.footer-link-icon {
  opacity: 0.7;
}
.footer-divider {
  width: 1px;
  height: 16px;
  background: #e2e8f0;
}
.footer-version {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  background: #eef3fb;
  font-size: 0.78em;
  font-weight: 600;
  color: #475569;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .app-footer {
    height: auto !important;
    padding: 16px 0 !important;
  }
  .footer-inner {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 0 16px;
    text-align: center;
  }
  .footer-section {
    justify-content: center !important;
    flex-wrap: wrap;
    flex: unset;
  }
  .footer-section--center {
    display: flex;
    order: -1;
  }
  .footer-dev-label {
    display: none;
  }
  .footer-divider {
    display: none;
  }
}
</style>
